import {TLang} from '../interfaces/TLang';


export const isRequiredLang = (value: TLang) => value === 'ua';
